import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cfafded"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "confirm" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title w-full pb-2" }, "お問合せ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "intro w-full" }, [
  /*#__PURE__*/_createElementVNode("p", null, "以下の内容で送信します。よろしいですか")
], -1))
const _hoisted_4 = { class: "content mt-6" }
const _hoisted_5 = { class: "confirm-table col-12 md:col-8" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "件名", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "担当者名", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "ご連絡電話番号", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "メールアドレス", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "お問合せ内容", -1))
const _hoisted_11 = { class: "col-12 md:col-8 flex justify-content-end mt-3 pr-0" }


import { ApiContactRequest } from "../../../typings";


export default /*#__PURE__*/_defineComponent({
  __name: 'confirm',
  props: {
    formContact: null
  },
  emits: ["back", "submit"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  formContact: ApiContactRequest;
};





const onClickBack = () => {
  emits("back", true);
};

const onClickSubmit = () => {
  emits("submit", true);
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _hoisted_6,
            _createElementVNode("td", null, _toDisplayString(props.formContact?.subject), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("td", null, _toDisplayString(props.formContact?.name), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("td", null, _toDisplayString(props.formContact?.phone_number), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_9,
            _createElementVNode("td", null, _toDisplayString(props.formContact?.email), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("td", null, _toDisplayString(props.formContact?.content), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_Button, {
          class: "p-button-light mr-3",
          label: "戻る",
          onClick: onClickBack
        }),
        _createVNode(_component_Button, {
          class: "btn-primary h-3rem w-3 border-transparent ml-3",
          label: "送信",
          onClick: onClickSubmit
        })
      ])
    ])
  ]))
}
}

})